import { setTerms } from '@/packages/JsonQuery/helpers';

export const setPlacement = setTerms('placement_type');
